import {asyncNames} from '../../lib/asyncUtil'
import {SIGN_IN, TFA_LOGIN, EXTEND_SESSION, SIGN_OUT} from '../actionTypes'

const initialState = {loading: false, user: {}, failed: false, error: null, message: null}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case asyncNames(SIGN_IN).loading:
    case asyncNames(TFA_LOGIN).loading:
    case asyncNames(EXTEND_SESSION).loading:
    case asyncNames(SIGN_OUT).loading:
      return {...state, loading: action.data, error: null, failed: false}
    case asyncNames(SIGN_IN).success:
    case asyncNames(TFA_LOGIN).success:
      return {...state, user: action.data, loading: false, failed: false, error: null}
    case asyncNames(SIGN_IN).failure:
    case asyncNames(TFA_LOGIN).failure:
    case asyncNames(EXTEND_SESSION).failure:
    case asyncNames(SIGN_OUT).failure:
      return {...state, loading: false, error: action.data.error, failed: action.data.status}
    case asyncNames(SIGN_OUT).success:
      return {...state, user: {}, message: action.data, loading: false}
    default:
      return state
  }
}

export default authReducer
